import booking from "./index.vue";
import PaymentsAndRecieptsApp from "./payments_and_receipts/app/index.vue";
import PaymentHub from '../navigation/payment-hub'

export default [
  {
    path: "/booking/:bookingNumber/:surname",
    name: "bookingauth",
    component: booking,
  },
  {
    path: "/booking/:bookingNumber/:surname/:source",
    name: "bookingauthsource",
    component: booking,
    props: (route) => ({
      bookingNumber: route.params.bookingNumber,
      surname: route.params.surname,
      source: route.params.source,
    }),
  },
  {
    path: "/booking/:bookingNumber/:surname/:source/:component",
    name: "bookingauthcomponent",
    component: booking,
    props: (route) => ({
      bookingNumber: route.params.bookingNumber,
      surname: route.params.surname,
      source: route.params.source,
      component: route.params.component,
    }),
  },
  {
    path: "/booking",
    name: "booking",
    component: booking,
    meta: {
      requiresAuth: true,
      breadCrumb(route) {
        const itineraryPage = route.params.itineraryPage;
        return [
          {
            text: "ViewTrail Home",
            to: { name: "landing" },
          },
          {
            text: "Itinerary",
          },
        ];
      },
    },
  },
  {
    path: "/friendandfamily/:unid",
    name: "friendandfamily",
    component: booking,
  },
  {
    path: "/weddingabroad/:unid",
    name: "weddingabroad",
    component: booking,
  },
  {
    path: "/amexpayment/:bookingNumber/:surname",
    name: "amexPayment",
    component: booking,
  },
  {
    path: "/contactlessPayment/:bookingNumber/:surname",
    name: "contactlessPayment",
    component: PaymentsAndRecieptsApp,
  },
  {
    path: '/flight-payment/:bookingNumber/:surname/:source', // route sent to clients via email/ notification, which will start with the payment modal open and the 'issue flights' checkbox ticked
    name: 'flightIssue',
    component: PaymentHub,
    props: (route) => ({
      bookingNumber: route.params.bookingNumber,
      surname: route.params.surname,
      source: route.params.source,
      issueFlights: true,
    }),
    meta: {
      breadCrumb() {
        return [
          {
            text: "ViewTrail Home",
            to: { name: "landing" },
          },
          {
            text: "Payment Hub",
          },
        ];
      },
    },
  },
];
